import { AllCommentsProps } from "../data-model/busniessOfficeNote";
import { BusniessOfficeReportType } from "../enums/busniessOfficeReportType";

/**
 * Extracts and transforms comments of type FINAL into a write-back format.
 * Filters comments to include only those with `BusniessOfficeReportType.FINAL` type,
 * then maps the first matching group's comments into a structured format for posting.
 *
 * @param {AllCommentsProps[]} comments - Array of comment groups to process.
 * @returns {{ note: string; report_status: string; report_identifier: string }[] | undefined}
 *          An array of formatted comments ready for write-back, or undefined if no FINAL comments exist.
 * @example
 * const comments = [{ type: BusniessOfficeReportType.FINAL, comments: [...] }];
 * const result = getCommentsToWriteFromAllComments(comments);
 * // Returns: [{ note: "...", report_status: "...", report_identifier: "..." }, ...]
 */
const getCommentsToWriteFromAllComments = (comments: AllCommentsProps[]) => {
  const getOnlyPostComments = comments.filter(
    (comment) => comment.type === BusniessOfficeReportType.FINAL,
  );

  if (getOnlyPostComments.length === 0) {
    return;
  }

  const allPostComments = getOnlyPostComments[0].comments.map((comment) => {
    return {
      note: comment.writeBackComment ?? "",
      report_status: comment.boStatus ?? "",
      report_identifier: comment.id,
    };
  });

  return allPostComments;
};

export { getCommentsToWriteFromAllComments };
